@if (isOpen()) {
  <div
    class="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto bg-black/50 backdrop-blur-sm animate-fade-in"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="report-issue-title">

    <div
      class="w-full max-w-2xl my-8 bg-card border border-border rounded-2xl shadow-xl animate-scale-in"
      (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="flex items-center justify-between gap-4 px-6 py-4 border-b border-border">
        <h2 id="report-issue-title" class="text-lg font-bold text-foreground">
          {{ created() ? 'Thank you!' : 'Report an Issue' }}
        </h2>
        <!-- Disabled mid-flight. Closing destroys the form and cancels the request — for a
             submit that means the issue may already exist server-side while the user is
             left with no reference number, so they file it again. -->
        <button type="button" (click)="close()" aria-label="Close"
          [disabled]="isBusy()"
          [title]="isBusy() ? 'Please wait — your report is being submitted' : 'Close'"
          class="p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
          <app-icon name="x" size="sm" />
        </button>
      </div>

      <div class="px-6 py-5">
        @if (created(); as issue) {
          <!-- Confirmation. Note: no resolution-time promise — we have no SLA tracking,
               so we do not make a commitment we cannot measure or honour. -->
          <div class="text-center py-6">
            <div class="mx-auto w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
              <app-icon name="check-circle" size="md" class="text-primary" />
            </div>

            <p class="text-foreground font-medium mb-1">Your issue has been submitted successfully.</p>

            <p class="text-sm text-muted-foreground mb-4">
              Reference ID:
              <span class="font-mono font-semibold text-foreground">{{ issue.issue_number }}</span>
            </p>

            <!-- Says what actually happens: email only on submit + resolve; progress in
                 the notification bell. Promising "updates by email" when we only send
                 two is a promise the system doesn't keep. -->
            <p class="text-sm text-muted-foreground mb-6">
              Our team will review it shortly. You'll see progress in your notifications,
              and we'll email you once it's resolved.
            </p>

            <div class="flex items-center justify-center gap-3">
              <app-button variant="outline" (click)="close()">Close</app-button>
              <app-button variant="primary" (click)="viewIssue()">View Issue</app-button>
            </div>
          </div>
        } @else {
          <app-report-issue-form
            [initialModule]="initialModule()"
            (submitted)="onSubmitted($event)"
            (cancelled)="close()" />
        }
      </div>
    </div>
  </div>
}
